'use strict';

const widgetObserver = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      entry.target.hydrate();
      widgetObserver.unobserve(entry.target);
    }
  }
}, { rootMargin: '200px 0px', threshold: 0 });

class LazyWidget extends HTMLElement {
  connectedCallback() {
    if (this._hydrated) return;
    widgetObserver.observe(this);
  }
  hydrate() {
    if (this._hydrated) return;
    this._hydrated = true;
    this._render();
  }
}

class HdtVariantSwitcher extends LazyWidget {
  _render() {
    let data;
    try { data = JSON.parse(this.dataset.cv); } catch { return; }
    if (!Array.isArray(data) || !data.length) return;

    if (data[0].f) {
      const fLabel = String(data[0].f);
      const isEmpty = fLabel.trim() === '';
      this.innerHTML =
        '<div class="card-variant-switcher" role="group" aria-label="Wariant produktu">' +
          '<button type="button" class="cvs-btn active' + (isEmpty ? ' cvs-btn--empty' : '') + '"' +
            ' aria-pressed="true" disabled' + (isEmpty ? ' aria-hidden="true"' : '') + '>' +
            escapeHTML(fLabel) +
          '</button>' +
        '</div>';
      return;
    }

    // Active flag: cache path nie niesie item.a — wyliczamy z pid vs data-current-pid
    // (active zależy od perspektywy, który produkt z listy jest aktualnie renderowany).
    // Fallback path (brak data-current-pid) używa item.a jak w starym snippecie.
    const currentPid = this.dataset.currentPid;
    const buttons = data.map(item => {
      const isActive = currentPid ? (String(item.pid) === currentPid) : !!item.a;
      return '<button type="button"' +
        ' class="cvs-btn ' + (isActive ? 'active' : '') + '"' +
        ' aria-label="Wybierz wariant ' + escapeAttr(item.s) + ' - ' + escapeAttr(item.t) + '"' +
        ' aria-pressed="' + (isActive ? 'true' : 'false') + '"' +
        ' data-id="' + item.id + '"' +
        ' data-title="' + escapeAttr(item.t) + '"' +
        ' data-url="' + escapeAttr(item.u) + '"' +
        ' data-price="' + escapeAttr(item.p) + '"' +
        (item.c ? ' data-compare-price="' + escapeAttr(item.c) + '"' : '') +
        ' data-img="' + escapeAttr(item.i) + '"' +
        (item.h ? ' data-img-hover="' + escapeAttr(item.h) + '"' : '') +
      '>' + escapeHTML(item.s) + '</button>';
    }).join('');

    this.innerHTML =
      '<div class="card-variant-switcher" role="group" aria-label="Dostępne warianty produktu">' +
        buttons +
      '</div>';
  }
}
try { customElements.define('hdt-variant-switcher', HdtVariantSwitcher); } catch (_) {}

class HdtScentSlider extends LazyWidget {
  _render() {
    let data;
    try { data = JSON.parse(this.dataset.cs); } catch { return; }
    if (!data || !Array.isArray(data.i) || !data.i.length) return;

    const label = data.k === 'm' ? 'Podobne nuty:' : 'Może Ci się spodobać:';
    const slides = data.i.map(item =>
      '<a href="' + escapeAttr(item.u) + '" class="card-scent-slide">' +
        '<div class="card-scent-inner">' +
          '<div class="card-scent-img">' +
            (item.g
              ? '<img src="' + escapeAttr(item.g) + '" alt="" loading="lazy" width="160" height="160">'
              : '<div style="background:#f0f0f0;width:100%;height:100%;"></div>') +
          '</div>' +
          '<div class="card-scent-info">' +
            '<p class="card-scent-name" title="' + escapeAttr(item.t) + '">' + escapeHTML(item.t) + '</p>' +
          '</div>' +
        '</div>' +
      '</a>'
    ).join('');

    const dots = data.i.length > 1
      ? '<div class="card-scent-dots">' +
          data.i.map((_, idx) =>
            '<div class="card-scent-dot ' + (idx === 0 ? 'active' : '') + '" data-index="' + idx + '"></div>'
          ).join('') +
        '</div>'
      : '';

    this.innerHTML =
      '<div class="card-scent-box">' +
        '<span class="card-scent-title">' + label + '</span>' +
        '<div class="card-scent-slider-container">' +
          '<div class="card-scent-track">' + slides + '</div>' +
          dots +
        '</div>' +
      '</div>';
  }
}
try { customElements.define('hdt-scent-slider', HdtScentSlider); } catch (_) {}

// Text content only; use escapeAttr for attribute values.
function escapeHTML(s) {
  return String(s).replace(/[&<>]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;'}[c]));
}
function escapeAttr(s) {
  return String(s).replace(/[&"']/g, c => ({'&':'&amp;','"':'&quot;',"'":'&#39;'}[c]));
}
